import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "sc_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  setToken(res.data.token);
  return res.data;
};

export const verifyAdmin = async () => {
  const res = await axios.get(`${API}/admin/verify`, { headers: authHeaders() });
  return res.data;
};

// Generic resource CRUD. resource: "announcements" | "events" | "partners" | "rates"
export const fetchPublic = async (resource) => {
  const res = await axios.get(`${API}/${resource}`);
  return res.data;
};

export const fetchAll = async (resource) => {
  const res = await axios.get(`${API}/admin/${resource}`, { headers: authHeaders() });
  return res.data;
};

export const createItem = async (resource, payload) => {
  const res = await axios.post(`${API}/admin/${resource}`, payload, { headers: authHeaders() });
  return res.data;
};

export const updateItem = async (resource, id, payload) => {
  const res = await axios.put(`${API}/admin/${resource}/${id}`, payload, { headers: authHeaders() });
  return res.data;
};

export const deleteItem = async (resource, id) => {
  const res = await axios.delete(`${API}/admin/${resource}/${id}`, { headers: authHeaders() });
  return res.data;
};

// Back-compat helper used by the ticker
export const fetchPublicAnnouncements = () => fetchPublic("announcements");

// Resolve a stored image path to a usable src.
// "/api/..." -> backend origin; http/https/data/other stay as-is.
export const resolveImg = (u) => {
  if (!u || typeof u !== "string") return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};

// Upload an image file to object storage. Returns a relative "/api/files/..." url.
export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await axios.post(`${API}/admin/upload`, fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return res.data; // { url, path }
};

// Site settings (singleton)
export const getSettings = async () => {
  const res = await axios.get(`${API}/settings`);
  return res.data;
};
export const updateSettings = async (patch) => {
  const res = await axios.put(`${API}/admin/settings`, patch, { headers: authHeaders() });
  return res.data;
};

// Courts
export const fetchCourtsAdmin = async () => {
  const res = await axios.get(`${API}/admin/courts`, { headers: authHeaders() });
  return res.data;
};
export const fetchCourtsPublic = async () => {
  const res = await axios.get(`${API}/courts`);
  return res.data;
};
export const fetchCourtPublic = async (slug) => {
  const res = await axios.get(`${API}/courts/${slug}`);
  return res.data;
};
export const updateCourt = async (slug, patch) => {
  const res = await axios.put(`${API}/admin/courts/${slug}`, patch, { headers: authHeaders() });
  return res.data;
};

// Featured Partner (spotlight section)
export const getFeaturedPartner = async () => {
  const res = await axios.get(`${API}/featured-partner`);
  return res.data;
};
export const updateFeaturedPartner = async (patch) => {
  const res = await axios.put(`${API}/admin/featured-partner`, patch, { headers: authHeaders() });
  return res.data;
};

// Newsletter
export const subscribeEmail = async (email) => {
  const res = await axios.post(`${API}/subscribe`, { email });
  return res.data;
};
